export default [
    {
      path: '/early-claim-total-ggt',
      component: () => import('./views/Index'),
      name: 'early-claim-total-ggt',
      redirect: { name: 'early-claim-total-ggt-list' },
      children: [
        {
          path: '',
          name: 'early-claim-total-ggt-list',
          component: () => import('./views/List'),
          meta: {
            resource: 'auth',
          },
        },
      ],
    },
  ]